import React from "react";
import { FavoriteBorder, Favorite } from "@mui/icons-material";

const HorizontalCard = ({
  imageUrl,
  title,
  location,
  isActive,
  className,
  isFavorite,
  onFavoriteToggle,
  favoriteIcon,
  onClick,
}) => {
  const handleCardClick = (e) => {
    // Check if the click didn't originate from the favorite button
    if (!e.target.closest("button")) {
      onClick();
    }
  };

  return (
    <div
      className={`relative flex items-center p-4 bg-white rounded-lg shadow-md cursor-pointer ${className}`}
      onClick={handleCardClick}
    >
      {/* <div className="flex-shrink-0 w-32 h-32 mr-10">
        <img
          src={imageUrl}
          alt={title}
          className="rounded-lg object-cover w-full h-full"
        />
      </div> */}
      <div className="flex-4">
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="text-gray-600">Location: {location}</p>
      </div>
      <div className="absolute bottom-4 right-4">
        <button onClick={onFavoriteToggle} className="focus:outline-none">
          {favoriteIcon}
        </button>
      </div>
      <div className="absolute top-4 right-4">
        <div
          className={`w-4 h-4 rounded-full ${
            isActive ? "bg-green-500" : "bg-gray-400"
          }`}
        ></div>
      </div>
    </div>
  );
};

export default HorizontalCard;
